/**
 * Add-to-calendar: click links whose href is #date=...&show=... to add the event.
 * Shows a menu: Google Calendar, Outlook, or Download .ics file.
 * Include this script and call addToCalendar.init() when the DOM is ready.
 */

(function (global) {
  'use strict';

  /**
   * Parse date string and return start/end in ICS format (UTC).
   * If no time is given, uses 20:00 (8 PM) local.
   */
  function toICSDate(dateStr, durationMinutes = 60) {
    const d = new Date(dateStr);
    if (isNaN(d.getTime())) return null;
    const dateOnly = /^\d{4}-\d{2}-\d{2}$/.test(String(dateStr).trim());
    if (dateOnly) d.setHours(20, 0, 0, 0);
    const start = d;
    const end = new Date(start.getTime() + durationMinutes * 60 * 1000);
    return {
      start: formatICSDateTime(start),
      end: formatICSDateTime(end),
      startDate: start,
      endDate: end,
    };
  }

  function formatICSDateTime(date) {
    return date.toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '');
  }

  /**
   * Escape text for use inside an ICS value.
   */
  function escapeICS(text) {
    if (text == null) return '';
    return String(text).replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/\r?\n/g, '\\n');
  }

  /**
   * URL to add event to Google Calendar (opens in new tab).
   */
  function googleCalendarURL(showName, dateStr, options) {
    const opts = options || {};
    const duration = opts.durationMinutes != null ? opts.durationMinutes : 60;
    const t = toICSDate(dateStr, duration);
    if (!t) return null;
    const params = new URLSearchParams({
      action: 'TEMPLATE',
      text: showName || 'Show',
      dates: t.start + '/' + t.end,
    });
    return 'https://www.google.com/calendar/render?' + params.toString();
  }

  /**
   * URL to add event to Outlook.com (opens in new tab).
   */
  function outlookCalendarURL(showName, dateStr, options) {
    const opts = options || {};
    const duration = opts.durationMinutes != null ? opts.durationMinutes : 60;
    const t = toICSDate(dateStr, duration);
    if (!t) return null;
    const params = new URLSearchParams({
      subject: showName || 'Show',
      startdt: t.startDate.toISOString(),
      enddt: t.endDate.toISOString(),
    });
    return 'https://outlook.live.com/calendar/0/action/compose?' + params.toString();
  }

  /**
   * Build and trigger download of an .ics file for one event.
   */
  function downloadICS(showName, dateStr, options) {
    const opts = options || {};
    const duration = opts.durationMinutes != null ? opts.durationMinutes : 60;
    const times = toICSDate(dateStr, duration);
    if (!times) return false;

    const uid = 'tellyvisions-' + Date.now() + '-' + Math.random().toString(36).slice(2) + '@add-to-calendar';
    const summary = escapeICS(showName || 'Show');
    const ics = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Tellyvisions//AddToCalendar//EN',
      'BEGIN:VEVENT',
      'UID:' + uid,
      'DTSTAMP:' + formatICSDateTime(new Date()),
      'DTSTART:' + times.start,
      'DTEND:' + times.end,
      'SUMMARY:' + summary,
      'END:VEVENT',
      'END:VCALENDAR',
    ].join('\r\n');

    const blob = new Blob([ics], { type: 'text/calendar;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = (showName || 'event').replace(/[^\w\s-]/g, '').replace(/\s+/g, '-') + '.ics';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
    return true;
  }

  /**
   * Show a small "Add to calendar" menu and handle choice.
   */
  function showAddToCalendarMenu(anchorEl, showName, dateStr, options) {
    var menu = document.getElementById('add-to-calendar-menu');
    if (menu) menu.remove();

    const t = toICSDate(dateStr, options.durationMinutes != null ? options.durationMinutes : 60);
    if (!t) return;

    const gUrl = googleCalendarURL(showName, dateStr, options);
    const oUrl = outlookCalendarURL(showName, dateStr, options);

    menu = document.createElement('div');
    menu.id = 'add-to-calendar-menu';
    menu.setAttribute('role', 'menu');
    menu.innerHTML =
      '<span class="add-to-calendar-title">Add to calendar</span>' +
      (gUrl
        ? '<a href="' + gUrl + '" target="_blank" rel="noopener" class="add-to-calendar-item" role="menuitem">Google Calendar</a>'
        : '') +
      (oUrl
        ? '<a href="' + oUrl + '" target="_blank" rel="noopener" class="add-to-calendar-item" role="menuitem">Outlook</a>'
        : '') +
      '<button type="button" class="add-to-calendar-item add-to-calendar-download" role="menuitem">Download .ics file</button>';

    var style = document.getElementById('add-to-calendar-styles');
    if (!style) {
      style = document.createElement('style');
      style.id = 'add-to-calendar-styles';
      style.textContent =
        '#add-to-calendar-menu{position:absolute;z-index:9999;min-width:180px;padding:6px 0;background:#fff;border:1px solid #ccc;border-radius:8px;box-shadow:0 4px 12px rgba(0,0,0,.15);font-family:system-ui,sans-serif;font-size:14px;}' +
        '#add-to-calendar-menu .add-to-calendar-title{display:block;padding:6px 12px;color:#666;font-size:12px;text-transform:uppercase;letter-spacing:.04em;}' +
        '#add-to-calendar-menu .add-to-calendar-item{display:block;width:100%;padding:8px 12px;border:0;background:0;color:#111;text-align:left;text-decoration:none;cursor:pointer;box-sizing:border-box;font-size:14px;font-family:inherit;}' +
        '#add-to-calendar-menu .add-to-calendar-item:hover{background:#f0f0f0;}' +
        '#add-to-calendar-menu .add-to-calendar-item:first-of-type{margin-top:4px;}';
      document.head.appendChild(style);
    }

    document.body.appendChild(menu);

    var rect = anchorEl.getBoundingClientRect();
    menu.style.left = rect.left + window.scrollX + 'px';
    menu.style.top = rect.bottom + window.scrollY + 4 + 'px';

    function closeOnOutside(e) {
      if (!menu.contains(e.target) && !anchorEl.contains(e.target)) {
        menu.remove();
        document.removeEventListener('click', closeOnOutside);
      }
    }

    function close() {
      menu.remove();
      document.removeEventListener('click', closeOnOutside);
    }

    menu.querySelectorAll('a.add-to-calendar-item').forEach(function (link) {
      link.addEventListener('click', close);
    });
    menu.querySelector('.add-to-calendar-download').addEventListener('click', function (e) {
      e.preventDefault();
      downloadICS(showName, dateStr, options);
      close();
    });

    document.addEventListener('click', closeOnOutside);
  }

  /**
   * Parse hash fragment for date and show: #date=YYYY-MM-DD&show=Title
   */
  function parseCalendarHash(hashStr) {
    if (!hashStr || hashStr.charAt(0) !== '#') return null;
    const query = hashStr.slice(1).replace(/&amp;/gi, '&');
    const params = {};
    query.split('&').forEach(function (pair) {
      const i = pair.indexOf('=');
      if (i !== -1) {
        params[decodeURIComponent(pair.slice(0, i).replace(/\+/g, ' '))] = decodeURIComponent(
          pair.slice(i + 1).replace(/\+/g, ' ')
        );
      }
    });
    const dateStr = params.date;
    const showName = params.show;
    if (!dateStr || showName === undefined) return null;
    return { dateStr: dateStr, showName: showName };
  }

  var LOG_PREFIX = '[add-to-calendar]';

  /**
   * Install click handler on container (or document) for links with href
   * hash encoding date and show (#date=...&show=...).
   */
  function init(container, options) {
    const root = container && container.nodeType === 1 ? container : document;
    const opts = options || {};
    //console.log(LOG_PREFIX + ' init: attaching click listener to', root === document ? 'document' : root);
    root.addEventListener('click', function (e) {
      const link = e.target.closest && e.target.closest('a[href^="#"]');
      if (!link || !link.getAttribute('href')) return;
      const href = link.getAttribute('href');
      //console.log(LOG_PREFIX + ' click on calendar link, href=', href);
      const parsed = parseCalendarHash(href);
      if (!parsed) {
        //console.log(LOG_PREFIX + ' parseCalendarHash returned null for href:', href);
        return;
      }
      //console.log(LOG_PREFIX + ' parsed:', parsed, '- preventing default and showing menu');
      e.preventDefault();
      e.stopPropagation();
      showAddToCalendarMenu(link, parsed.showName, parsed.dateStr, opts);
    });
    //console.log(LOG_PREFIX + ' init: listener added');
  }

  const addToCalendar = {
    init: init,
    parseCalendarHash: parseCalendarHash,
    downloadICS: downloadICS,
    googleCalendarURL: googleCalendarURL,
    outlookCalendarURL: outlookCalendarURL,
  };

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = addToCalendar;
  } else {
    global.addToCalendar = addToCalendar;
    if (typeof window !== 'undefined') {
      function autoInit() {
        addToCalendar.init(document, { durationMinutes: 60 });
      }
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', autoInit);
      } else {
        autoInit();
      }
    }
  }
})(typeof window !== 'undefined' ? window : this);
